const types = require('../../constants/actionTypes');

const optionSelected = ({ option }) => ({
    type: types.PROFIT_RISK_OPTION_SELECTED,
    payload: { option },
});


module.exports = optionSelected;
